const frontendURL = '/cat/province/';
const backendURL = '/api/references/province/';
const name = 'Областя';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
